module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAjElEQVRIx2NgMGiCI27zGiBCFoGgTIXoSwImcATkYqrBgpA5ISnhQERloxkNG4vKPb6fZAEiIAPIpaarOUzrLm0SByIgg8oBImpbzm9ZBURABnWM/k8EeNE+E9loIJcYXaNG09FojekaBFFtsB6y0UAuMbpGjaaj0f/PEUYv8qVQUki+FDG6Ro2mn9EAj0uRLDYF888AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/cf.png
// module id = 253
// module chunks = 0